export function formatNumber({ no, style = 'currency', currency = "USD" }: { no: number, style?: string; currency?: string; }) {
    return new Intl.NumberFormat("en-IN", { style, currency }).format(no);
}
